function qtyPlus(){

    "use strict";
    var QTYPLUS = '.qtyplus',
        QTYMINUS = '.qtyminus';

    $( QTYPLUS ).click(function(e){
        e.preventDefault();
        var fieldName = $(this).attr('field');
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        if (!isNaN(currentVal) ) {
            $('input[name='+fieldName+']').val(currentVal + 1);
        }
        else {
            $('input[name='+fieldName+']').val(1);
        }
    });

    $( QTYMINUS ).click(function(e) {
        e.preventDefault();
        var fieldName = $(this).attr('field'),
            currentVal = parseInt($('input[name='+fieldName+']').val()),
            ZERO_ONE = $(this).hasClass('oak');
        if (!ZERO_ONE) {
            if (!isNaN(currentVal) && currentVal > 1) {
                $('input[name='+fieldName+']').val(currentVal - 1);
            } else {
                $('input[name='+fieldName+']').val(1);
            }
        }
    });

}

module.exports = qtyPlus;


// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/components/global/09_qtyplus.js